import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStaffPage } from "@/api/management/staff";
export default {
  name: "staffRoster",
  data: function data() {
    return {
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      stafflist: [{
        label: "工号",
        prop: "code",
        width: "80"
      }, {
        label: "姓名",
        prop: "name",
        width: "80"
      }, {
        label: "性别",
        prop: "gendervalue",
        width: "80"
      }, {
        label: "出生日期",
        prop: "dateofbirth",
        width: "80"
      }, {
        label: "身份证号码",
        prop: "credentialnumber",
        width: "100"
      }, {
        label: "身份证住址",
        prop: "householdaddress",
        width: "100"
      }, {
        label: "民族",
        prop: "nationvalue",
        width: "80"
      }, {
        label: "籍贯",
        prop: "householdprovince2value",
        width: "80"
      }, {
        label: "出生地",
        prop: "householdprovince1value",
        width: "80"
      }, {
        label: "参加工作时间",
        prop: "startworktime",
        width: "120"
      }, {
        label: "党派",
        prop: "politicalstatusvalue",
        width: "80"
      }, {
        label: "岗位职务",
        prop: "post",
        width: "100"
      }, {
        label: "行政级别",
        prop: "mainjobgradesvalue",
        width: "100"
      }, {
        label: "任现职务时间",
        prop: "jointime",
        width: "120"
      }, {
        label: "职称等级",
        prop: "jobtitlevalue",
        width: "100"
      }, {
        label: "科室",
        prop: "deptName",
        width: "80"
      }]
    };
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    getTableData: function () {
      var _getTableData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$getStaffPage, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                params = {
                  current: this.pageNum,
                  size: this.pageSize
                };
                _context.next = 4;
                return getStaffPage(params);

              case 4:
                _yield$getStaffPage = _context.sent;
                data = _yield$getStaffPage.data;
                this.loading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.msg);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTableData() {
        return _getTableData.apply(this, arguments);
      }

      return getTableData;
    }(),
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getTableData();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getTableData();
    }
  }
};